module.exports = __webpack_public_path__ + "static/media/r7.6ba4a5c2.jpg";